// extracted by mini-css-extract-plugin
export default {"container":"EventPage_container__8sJXi","content":"EventPage_content__Q65K0"};